<template>
  <div class="content">
    <hcp-downloads v-if="isHcpView"></hcp-downloads>
    <patient-downloads v-if="!isHcpView"></patient-downloads>
  </div>
</template>
<script>
  import HCPMixin from '../../mixins/HCPMixin';
  import HcpDownloads from "../../components/Downloads/HCPDownloads";
  import PatientDownloads from "../../components/Downloads/PatientDownloads";
  export default {
    components: {
      PatientDownloads,
      HcpDownloads
    },
    name: 'downloads',
    mixins: [HCPMixin],
  }
</script>
<style lang="less">
  @import "./Downloads.less";
</style>



// WEBPACK FOOTER //
// Downloads.vue?2b30c605